import React, { useContext } from 'react';
import { useQuery } from 'urql';
import { UserContext } from 'app/context/UserContext';
import {
    SimilarVideoContentQueryQuery,
    SimilarVideoContentQueryQueryVariables,
} from 'app/graphql/__generated__/types/contento';
import SimilarVideoContent from './SimilarVideoContent';
import SimlilarContentQuery from './SimilarVideoContentQuery.graphql';

type Props = {
    id: string;
};

const SimilarVideoContentContainer = ({ id }: Props) => {
    const { isAbroad: userIsAbroad } = useContext(UserContext);
    const [result] = useQuery<SimilarVideoContentQueryQuery, SimilarVideoContentQueryQueryVariables>({
        query: SimlilarContentQuery,
        variables: {
            id,
            userIsAbroad,
        },
    });

    if (!result?.data?.detailsPage || result.data.detailsPage.associatedContent.length === 0) {
        return null;
    }

    const relatedContent = result.data.detailsPage.associatedContent[0];

    const listTracking = {
        listId: relatedContent?.analyticsIdentifiers?.listId,
        listType: relatedContent?.analyticsIdentifiers?.listType,
    };

    return (
        <SimilarVideoContent
            headerText={relatedContent.name}
            listContent={relatedContent.items}
            listTracking={listTracking}
        />
    );
};

export default SimilarVideoContentContainer;
